import {kratosApi} from '../../../shared';

interface Flow {
  id: string;
  ui: {
    nodes: {
      attributes: {
        name: string;
        value: string;
      };
    }[];
  };
}

interface LogoutResponse {
  logout_url: string;
}

export const kratosAuth = {
  initLoginFlow: () => kratosApi.get<Flow>('/self-service/login/browser?refresh=true'),
  submitLogin: (flowId: string, identifier: string, password: string, csrfToken: string) =>
    kratosApi.post(`/self-service/login?flow=${flowId}`, {
      method: 'password',
      identifier,
      password,
      csrf_token: csrfToken,
    }),
  requestCodeLogin: (flowId: string, identifier: string, csrfToken: string) =>
    kratosApi.post(`/self-service/login?flow=${flowId}`, {
      method: 'code',
      identifier,
      csrf_token: csrfToken,
    }),
  submitCodeLogin: (flowId: string, identifier: string, code: string, csrfToken: string) =>
    kratosApi.post(`/self-service/login?flow=${flowId}`, {
      method: 'code',
      identifier,
      code,
      csrf_token: csrfToken,
    }),
  checkSession: () => kratosApi.get('/sessions/whoami'),
  logout: () => {
    return kratosApi.get<LogoutResponse>('/self-service/logout/browser').then((res) => {
      // Kratos возвращает logout_url как абсолютный URL на свой публичный домен.
      // Если ходить по нему напрямую, axios игнорирует baseURL и запрос минует прокси,
      // а вместе с ним теряется host-only сессионная кука (Domain снят cookieDomainRewrite),
      // из-за чего Kratos отвечает 401. Поэтому вытаскиваем token и зовём относительный путь
      // через тот же kratosApi — запрос снова идёт через прокси с правильной кукой.
      const token = new URL(res.data.logout_url).searchParams.get('token');

      return kratosApi
        .get(`/self-service/logout?token=${token}`, {
          validateStatus: (status) => {
            return status >= 200 && status < 300;
          },
        })
        .then((response) => {
          window.location.reload();
          return response;
        })
        .catch((error) => {
          if (error.response && error.response.status === 204) {
            window.location.reload();
            return {status: 204};
          }
          throw error;
        });
    });
  },
};
